export const checklistCategories = [
  {
    id: 'water-food',
    title: 'Water & Food',
    icon: 'ri-drop-line',
    color: 'blue',
    items: [
      { id: 1, text: 'One gallon of water per person per day (3-day supply minimum)', checked: false },
      { id: 2, text: 'Non-perishable food (3-day supply minimum)', checked: false },
      { id: 3, text: 'Manual can opener', checked: false },
      { id: 4, text: 'Paper plates, cups, and plastic utensils', checked: false },
      { id: 5, text: 'Water purification tablets or filter', checked: false },
    ],
  },
  {
    id: 'first-aid',
    title: 'First Aid & Medical',
    icon: 'ri-first-aid-kit-line',
    color: 'red',
    items: [
      { id: 6, text: 'First aid kit with bandages, gauze, tape', checked: false },
      { id: 7, text: 'Prescription medications (7-day supply)', checked: false },
      { id: 8, text: 'Over-the-counter pain relievers', checked: false },
      { id: 9, text: 'Antibiotic ointment', checked: false },
      { id: 10, text: 'Thermometer', checked: false },
      { id: 11, text: 'Medical records and insurance cards (copies)', checked: false },
    ],
  },
  {
    id: 'tools-supplies',
    title: 'Tools & Supplies',
    icon: 'ri-tools-line',
    color: 'orange',
    items: [
      { id: 12, text: 'Battery-powered or hand-crank radio (NOAA Weather Radio)', checked: false },
      { id: 13, text: 'Flashlight with extra batteries', checked: false },
      { id: 14, text: 'Multi-tool or Swiss Army knife', checked: false },
      { id: 15, text: 'Duct tape and plastic sheeting', checked: false },
      { id: 16, text: 'Matches in waterproof container', checked: false },
      { id: 17, text: 'Fire extinguisher', checked: false },
      { id: 18, text: 'Whistle to signal for help', checked: false },
      { id: 19, text: 'Local maps', checked: false },
    ],
  },
  {
    id: 'documents',
    title: 'Important Documents',
    icon: 'ri-file-text-line',
    color: 'purple',
    items: [
      { id: 20, text: 'Copies of insurance policies', checked: false },
      { id: 21, text: 'Identification documents (driver\'s license, passport)', checked: false },
      { id: 22, text: 'Bank account records', checked: false },
      { id: 23, text: 'Emergency contact list', checked: false },
      { id: 24, text: 'Family photos (for identification purposes)', checked: false },
      { id: 25, text: 'Store in waterproof container', checked: false },
    ],
  },
  {
    id: 'clothing-bedding',
    title: 'Clothing & Bedding',
    icon: 'ri-shirt-line',
    color: 'teal',
    items: [
      { id: 26, text: 'Complete change of clothing for each person', checked: false },
      { id: 27, text: 'Sturdy shoes or work boots', checked: false },
      { id: 28, text: 'Rain gear', checked: false },
      { id: 29, text: 'Blankets or sleeping bags', checked: false },
      { id: 30, text: 'Hat and gloves', checked: false },
    ],
  },
  {
    id: 'sanitation',
    title: 'Sanitation & Hygiene',
    icon: 'ri-hand-sanitizer-line',
    color: 'green',
    items: [
      { id: 31, text: 'Toilet paper and paper towels', checked: false },
      { id: 32, text: 'Soap and hand sanitizer', checked: false },
      { id: 33, text: 'Feminine hygiene products', checked: false },
      { id: 34, text: 'Plastic garbage bags and ties', checked: false },
      { id: 35, text: 'Household bleach (for sanitization)', checked: false },
      { id: 36, text: 'Personal hygiene items (toothbrush, toothpaste)', checked: false },
    ],
  },
  {
    id: 'special-needs',
    title: 'Special Needs Items',
    icon: 'ri-heart-pulse-line',
    color: 'pink',
    items: [
      { id: 37, text: 'Baby formula, diapers, bottles', checked: false },
      { id: 38, text: 'Pet food and water for pets', checked: false },
      { id: 39, text: 'Prescription eyeglasses or contact lenses', checked: false },
      { id: 40, text: 'Hearing aid batteries', checked: false },
      { id: 41, text: 'Mobility aids (cane, walker)', checked: false },
    ],
  },
  {
    id: 'communication',
    title: 'Communication & Power',
    icon: 'ri-smartphone-line',
    color: 'indigo',
    items: [
      { id: 42, text: 'Cell phone with chargers and backup battery', checked: false },
      { id: 43, text: 'Emergency contact numbers written down', checked: false },
      { id: 44, text: 'Portable power bank', checked: false },
      { id: 45, text: 'Solar charger', checked: false },
    ],
  },
  {
    id: 'cash-keys',
    title: 'Cash & Keys',
    icon: 'ri-money-dollar-circle-line',
    color: 'yellow',
    items: [
      { id: 46, text: 'Cash and credit cards', checked: false },
      { id: 47, text: 'Extra set of car and house keys', checked: false },
    ],
  },
  {
    id: 'entertainment',
    title: 'Entertainment & Comfort',
    icon: 'ri-gamepad-line',
    color: 'cyan',
    items: [
      { id: 48, text: 'Books, games, puzzles for children', checked: false },
      { id: 49, text: 'Comfort items (stuffed animal, favorite toy)', checked: false },
      { id: 50, text: 'Playing cards or travel games', checked: false },
    ],
  },
];

export const preparednessStats = [
  {
    icon: 'ri-time-line',
    value: '72 Hours',
    label: 'Minimum Supply Duration',
    description: 'Be prepared to be self-sufficient for at least 3 days',
  },
  {
    icon: 'ri-refresh-line',
    value: 'Every 6 Months',
    label: 'Kit Review Frequency',
    description: 'Check expiration dates and update supplies regularly',
  },
  {
    icon: 'ri-map-pin-line',
    value: '3 Locations',
    label: 'Recommended Kit Placement',
    description: 'Home, car, and workplace for maximum preparedness',
  },
];

export const kitStorageTips = [
  {
    icon: 'ri-box-3-line',
    title: 'Use Portable Containers',
    description: 'Store items in easy-to-carry containers like backpacks or plastic bins with handles.',
  },
  {
    icon: 'ri-temp-cold-line',
    title: 'Cool, Dry Location',
    description: 'Keep your kit in a cool, dry place away from direct sunlight and extreme temperatures.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Easy Access',
    description: 'Store in a location that all family members know about and can easily access.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Label & Date',
    description: 'Clearly label your kit and mark the date when items were added or last checked.',
  },
];

export const familyPlanSteps = [
  {
    step: 1,
    title: 'Identify Meeting Places',
    description: 'Choose two meeting locations: one near your home for sudden emergencies, and one outside your neighborhood in case you can\'t return home.',
    icon: 'ri-map-pin-2-line',
  },
  {
    step: 2,
    title: 'Establish Communication Plan',
    description: 'Designate an out-of-state contact person. Local phone lines may be jammed, but long-distance calls may go through.',
    icon: 'ri-phone-line',
  },
  {
    step: 3,
    title: 'Plan Evacuation Routes',
    description: 'Know multiple ways to exit your home and neighborhood. Practice your evacuation plan with all family members.',
    icon: 'ri-route-line',
  },
  {
    step: 4,
    title: 'Document Special Needs',
    description: 'Make a list of any special needs for family members, including medications, medical equipment, or dietary requirements.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: 5,
    title: 'Practice Your Plan',
    description: 'Conduct family drills at least twice a year. Update your plan as your family\'s needs change.',
    icon: 'ri-repeat-line',
  },
];
